<template>
  <div style="padding-left: 350px; padding-right: 350px">
    <v-img :src="logo"/>
  </div>

</template>

<script>

export default {
  name: 'DashboardDashboard',

  data() {
    return {
      logo: require('../../assets/logo.png')
    }
  },
}
</script>
